export const paymentFeatureWrapper = {
  background: "#F6F9FC",
  padding: "8.375rem 7rem",
};

export const sectionContent2 = {
  lineHeight: "1.5rem",
  color: "#12141D",
  opacity: ".7",
};
